import Resources from '../../helpers/resources';
import { handleResourceError, handleResourceSuccess } from '../../helpers/resource-handlers';

export const CLASS_DETAILS_DATA_RETRIEVED = 'CLASS_DETAILS_DATA_RETRIEVED';

function getClassDetailsData(classroomId, startDate, endDate) {
    return dispatch => Resources
        .classDetails
        .get({ classroomId })
        .withBody({ startDate, endDate })
        .send()
        .then(
            (payload) => {
                const { studentParticipations } = payload.data;
                const mappedData = studentParticipations.map((item) => {
                    const { newCertificates, totalCertificates, total }
                        = item;
                    return {
                        id: item.userProfileId,
                        student: `${item.firstName} ${item.lastName}`,
                        firstName: item.firstName,
                        lastName: item.lastName,
                        participationPoints: item.activityPoints,
                        liveMathsPoints: item.liveMathsPoints,
                        goldPast: item.gold,
                        silverPast: item.silver,
                        bronzePast: item.bronze,
                        totalCertificates,
                        totalPast: total,
                        totalNew: newCertificates.total,
                        ...newCertificates
                    };
                });

                return handleResourceSuccess(dispatch, payload, {
                    type: CLASS_DETAILS_DATA_RETRIEVED,
                    payload: mappedData
                });
            },
            error => handleResourceError(dispatch, error)
        );
}

export default {
    getClassDetailsData
};




// WEBPACK FOOTER //
// ./containers/class-details/class-details-actions.js